// extracted by mini-css-extract-plugin
export default {"mobile_nav":"mobileMenu_mobile_nav__C4g+q","item":"mobileMenu_item__WIEQp"};